const asyncCopyFallback = text => {
  if (document) {
    const prevFocusElement = document.activeElement
    const textArea = document.createElement('textarea')

    let successful = false
    let error = 'Copy failed'

    // setup dummy textarea & focus it
    textArea.value = text
    textArea.setAttribute('class', 'sr-only')
    document.body.appendChild(textArea)
    textArea.select()

    // try the command
    try {
      successful = document.execCommand('copy')
      
      if (prevFocusElement) {
        prevFocusElement.focus()
      }
    } catch (err) {
      error = err
    }

    // cleanup
    document.body.removeChild(textArea)

    // allow async reactions
    return successful ? Promise.resolve() : Promise.reject(new Error(error))
  }
}

const asyncCopy = text =>
  navigator.clipboard
    ? navigator.clipboard.writeText(text)
    : asyncCopyFallback(text)

// must return a Promise
export const copy = asyncCopy
